import registrationApi from './registration-api';

export * from './registration-payload';
export * from './models';

export default registrationApi;
